var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C12.9062 0 16.5 3.59375 16.5 8C16.5 12.4375 12.9062 16 8.5 16C4.0625 16 0.5 12.4375 0.5 8C0.5 3.59375 4.0625 0 8.5 0ZM8.5 4C7.9375 4 7.5 4.46875 7.5 5C7.5 5.5625 7.9375 6 8.5 6C9.03125 6 9.5 5.5625 9.5 5C9.5 4.46875 9.03125 4 8.5 4ZM9.75 12C10.1562 12 10.5 11.6875 10.5 11.25C10.5 10.8438 10.1562 10.5 9.75 10.5H9.25V7.75C9.25 7.34375 8.90625 7 8.5 7H7.5C7.0625 7 6.75 7.34375 6.75 7.75C6.75 8.1875 7.0625 8.5 7.5 8.5H7.75V10.5H7.25C6.8125 10.5 6.5 10.8438 6.5 11.25C6.5 11.6875 6.8125 12 7.25 12H9.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInfo);
export default __webpack_public_path__ + "static/media/circle-info.adaecda49c494c5b224a23785d91d171.svg";
export { ForwardRef as ReactComponent };